const AddFolderIcon = () => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 175.12 139.25"
      xmlns="http://www.w3.org/2000/svg"
      className="add-folder-icon"
    >
      <g transform="translate(-21.142 -91.084)">
        <g stroke="#f9f9f9">
          <path
            d="m39.871 94.359 0.0031 0.0682h-1.7544c-7.5967 0-13.712 6.1156-13.712 13.712v31.399c0 0.51149 0.03226 1.0149 0.0863 1.5115v70.997c0 8.3239 6.701 15.025 15.025 15.025h138.45c8.3239 0 15.025-6.701 15.025-15.025v-84.849c0-8.3239-6.7016-15.025-15.025-15.025h-69.546l-18.067-17.657z"
            fill="none"
            stroke-width="6.5302"
          />
          <g
            transform="translate(-5.9345 -2.9873)"
            fill="#f9f9f9"
            stroke-width=".22296"
          >
            <rect
              x="109.01"
              y="134.07"
              width="11.261"
              height="77.954"
              ry="9.5733"
            />
            <rect
              transform="rotate(90)"
              x="167.42"
              y="-153.61"
              width="11.261"
              height="77.954"
              ry="9.5733"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AddFolderIcon